<template lang="pug">
  .locdelimiter
    svg.locdelimiter_svg(width="20" height="20" viewBox="0 0 20 20")
      g.locdelimiter_group
        g.locdelimiter_rotate( v-bind:class='{"locdelimiter_rotate-active": active}')
          line.locdelimiter_line(x1="-5" y1="0" x2="5" y2="0" v-bind:class='{"locdelimiter_line-active": active}')
          line.locdelimiter_line(x1="0" y1="-5" x2="0" y2="5" v-bind:class='{"locdelimiter_line-active": active}')
</template>
<script>
  export default{
    props: ['active']
  }
</script>
<style lang="sass">
  .locdelimiter
    &_group
      transform: translate(10px, 10px)
    &_rotate
      transition: transform .1s linear
      &-active
        transform: rotate(135deg) scale(1.414)
    &_line
      stroke: #ccc
      stroke-width: 2
      transition: stroke .1s linear
      &-active
        stroke: #000
</style>